<template>
  <div class="home">
    <MySwiper :picData="pictureData.introduction.top_banner" :swiperOption="swiperOption" />
    <div class="sd_content">
      <div class="title">走进修正</div>
      <ul v-if="introductionInfo.introduce">
        <li
          class="sd_item"
          :style="{ width: widthVal, overflow: 'hiddens' }"
          :class="!show ? 'open' : ''"
        >
          <div class="cover_box" @mouseenter="mouse">
            <img :src="introductionInfo.introduce[0].thumbnail" alt />
          </div>
          <div class="linner_box">
            <img class="img" :src="introductionInfo.introduce[0].image" alt />
            <img
              v-if="introductionInfo.introduce[0].video_path"
              class="play_icon"
              src="../../assets/image/play.png"
              @click="videoPlay(introductionInfo.introduce[0].video_path)"
              alt
            />
            <div class="text_content_wrap">
              <div class="text_content">
                <div class="titles">{{ introductionInfo.introduce[0].title }}</div>
                <p>{{ introductionInfo.introduce[0].content }}</p>
              </div>
            </div>
          </div>
        </li>
        <li
          class="sd_item"
          :style="{ width: widthVal_2, overflow: 'hiddens' }"
          :class="show1 ? 'open' : ''"
        >
          <div class="cover_box" @mouseenter="mouse1">
            <img :src="introductionInfo.introduce[1].thumbnail" alt />
          </div>
          <div class="linner_box">
            <img class="img" :src="introductionInfo.introduce[1].image" alt />
            <img
              v-if="introductionInfo.introduce[1].video_path"
              class="play_icon"
              src="../../assets/image/play.png"
              @click="videoPlay(introductionInfo.introduce[1].video_path)"
              alt
            />
            <div class="text_content_wrap">
              <div class="text_content">
                <div class="titles">{{ introductionInfo.introduce[1].title }}</div>
                <p>{{ introductionInfo.introduce[1].content }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 领导人 -->
    <!-- <div class="leader_box">
      <div
        class="leader"
        v-for="(leader, index) in introductionInfo.navigator"
        :key="index"
      >
        <div class="leader_img">
          <img :src="leader.thumbnail" alt v-if="leader.thumbnail != ''"/>
        </div>
        <div class="leader_content">
          <div class="leader_header">
            <div class="name">{{ leader.title }}</div>
            <div class="tag">
              <img src="../../assets/image/leader_logo.png" alt />
            </div>
          </div>
          <div class="leader_txt">{{ leader.content }}</div>
        </div>
      </div>
    </div>-->
    <!-- 任务介绍 -->
    <TaskIntro />
    <!-- 热点新闻 -->
    <div class="hot_news">
      <div class="new_title">热点新闻</div>
      <div class="new_sub_title">关注修正集团最新热点新闻</div>
      <div class="new_box">
        <swiper
          v-if="swiperData.length"
          ref="mySwiper"
          :options="swiperOptionsNews"
          class="swiper_box"
        >
          <swiper-slide v-for="(item, i) in swiperData" :key="i" class="slide">
            <div class="new_item_box" v-if="swiperData[i]">
              <div
                class="news_item"
                v-for="hotNew in swiperData[i]"
                :key="hotNew?.article_id"
                @click="goDetailArticle(hotNew.article_id)"
                @mouseenter="Enter"
                @mouseleave="Leave"
              >
                <img src="../../assets/image/hot_logo.png" alt class="hot_img" />
                <div class="newsItem_logo">
                  <img src="../../assets/image/new_logo.png" alt />
                </div>
                <div class="newsItem_content">
                  <div class="newsItem_title">{{ hotNew?.title }}</div>
                  <div class="newsItem_txt">
                    {{ hotNew?.subtitle.slice(0, 200) }}
                    <span>[</span>
                    <span style="cursor: pointer; color: #014ea2" class="newsinfo">详情</span>
                    <span>]</span>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div v-show="swiperData.length > 1" class="swiper-pagination1" slot="pagination"></div>
      </div>

      <div class="news_btn" @click="$router.push('/pressCenter')">查看更多</div>
    </div>
    <!-- <div
          class="news_item"
          v-for="hotNew in hotNewsList"
          :key="hotNew.article_id"
          @click="goDetailArticle(hotNew.article_id)"
        >
          <img src="../../assets/image/hot_logo.png" alt class="hot_img" />
          <div class="newsItem_logo">
            <img src="../../assets/image/new_logo.png" alt />
          </div>
          <div class="newsItem_content">
            <div class="newsItem_title">{{ hotNew.title }}</div>
            <div class="newsItem_txt">
              {{ hotNew.subtitle.slice(0, 200) }}
              <span>[</span>
              <span style="cursor: pointer; color: #014ea2">详情</span>
              <span>]</span>
            </div>
          </div>
    </div>-->
    <!-- 集团产品 -->
    <div class="product">
      <div class="product_title">集团产品</div>
      <div class="product_subTitle">良心药 放心药 管用的药</div>
      <div class="swiper1">
        <swiper :options="swiperOptions1" class="swiper_box">
          <swiper-slide v-for="(item, i) in productList" :key="i" class="slide">
            <img :src="item.thumbnail" alt />
            <div class="mask_wrap" :data-id="item.id">
              <div class="mask">
                <div class="mask_title">{{ item.name }}</div>
                <div class="mask_txt">{{ item.drug_function }}</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div slot="button-prev" class="swiper-button-prev">
            <img src="../../assets/image/left_btn.png" alt />
          </div>
          <div slot="button-next" class="swiper-button-next">
            <img src="../../assets/image/right_btn.png" alt />
          </div>
        </swiper>
      </div>
      <div class="product_btn" @click="$router.push('/groupProducts')">查看更多</div>
    </div>
    <!-- 广告位 -->
    <div class="banner_img" v-if="pictureData.introduction.bottom_adv?.length > 1">
      <swiper :options="swiperOptions3" ref="my_swiper" class="swiper_box3">
        <swiper-slide
          v-for="(pic, index) in pictureData.introduction.bottom_adv"
          :key="index"
          :data-index="index"
        >
          <img :src="pic.url" alt @click="goUrl(pic.redirect_to)" />
        </swiper-slide>
      </swiper>
    </div>
    <div class="banner_img" v-if="pictureData.introduction.bottom_adv?.length == 1">
      <img
        :src="pic.url"
        alt
        v-for="(pic, index) in pictureData.introduction.bottom_adv"
        :key="index"
        @click="goUrl(pic.redirect_to)"
      />
    </div>

    <div class="video_box" v-if="isShowVideo" @click="closeVideo">
      <img class="video_close" src="../../assets/image/video_close.png" />
      <div class="video_wrap" @click.stop>
        <video autoplay muted ref="video" :src="videoSrc" class="video" controls="controls" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MySwiper from "@/components/common/swiper.vue";
import { getIntroIndex } from "@/api";
import TaskIntro from "./components/taskIntro.vue";
export default {
  name: "Index",
  data() {
    return {
      swiperList: "",
      widthVal: "",
      widthVal_2: "74.5%",
      show: true,
      show1: true,
      introductionInfo: [],
      hotNewsList: [],
      productList: [],
      swiperData: [],
      swiperOption: {
        loop: true, // 是否循环播放
        speed: 400, // 切换速度 ms
        // allowTouchMove: false, // 是否允许鼠标滑动
        // touchRatio: 0.5,
        // touchAngle: 10, // 是否允许手指滑动
        // effect: 'fade', // 切换方式
        centeredSlides: true,

        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }

        // preventLinksPropagation: false, // 阻止点击事件冒泡
        // preloadImages: false // 是否强制加载所有图片
      },

      swiperOptions3: {
        slidesPerView: "auto", //设置slider容器能够同时显示的slides数量
        loop: true, //循环
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
        // on:{
        //   click:()=>{

        //   }
        // }
      },
      isShowVideo: false,
      videoSrc: ""
    };
  },
  components: { MySwiper, TaskIntro },
  methods: {
    Enter() {
      this.swiper.autoplay.stop();
    },
    Leave() {
      this.swiper.autoplay.start();
    },
    goUrl(url) {
      console.log(url);
      if (url) {
        window.open(url);
      }
    },
    mouse() {
      //走进修正动效处理
      (this.widthVal = "74.5%"), // 图片宽度/ul的宽度
        (this.widthVal_2 = "23.7%");
      this.show = false;
      this.show1 = false;
    },
    mouse1() {
      (this.widthVal = "23.7%"), (this.widthVal_2 = "74.5%");
      this.show1 = true;
      this.show = true;
    },
    // goProduct(item) {

    // this.$router.push({
    //   name: "detail",
    //   query: {
    //     id: item.id,
    //     type: "product",
    //     scene: 1,
    //     category_id: 0,
    //     keyword: "",
    //   },
    // });
    // },
    goDetailArticle(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
          type: "article",
          scene: 1,
          nav_id: 0,
          keyword: ""
        }
      });
    },
    goDetailProduct(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
          type: "product",
          scene: 1,
          category_id: 0,
          keyword: ""
        }
      });
    },
    videoPlay(src) {
      console.log(src);
      this.videoSrc = src;
      this.isShowVideo = true;
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    },
    closeVideo() {
      this.isShowVideo = false;
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
    getswiperData(arr) {
      const length = 4 - (arr % 4);
      for (let i = 0; i < length; i++) {
        arr.push(arr[i]);
      }
      let result = [];
      for (let i = 0; i < arr.length; i += 4) {
        result.push(arr.slice(i, i + 4));
      }
      return result;
    }
  },
  computed: {
    ...mapState({
      // introductionInfo: (state) => state.intro.introduction,
      // hotNewsList: (state) => state.intro.hot_news,
      // productList: (state) => state.intro.product,
      pictureData: state => state.material.pictureData
    }),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },

    swiperOptionsNews() {
      return {
        // slidesPerView: "auto", //设置slider容器能够同时显示的slides数量
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination1",
          clickable: true
        },
        loop: true, //循环
        autoplay:
          this.swiperData.length > 1
            ? {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: true
              }
            : false,
        observeParents: true,
        observer: true
      };
    },
    swiperOptions1() {
      return {
        speed: 1000, //滚动速度
        slidesPerView: 4,
        spaceBetween: 20,
        // slidesPerGroupAuto: true,
        slidesPerGroup: 4,
        loop:  true , //循环
        // observer:true,//修改swiper自己或子元素时，自动初始化swiper
        // observeParents:true,//修改swiper的父元素时，自动初始化swiper
        // loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2000, //在每一屏延迟时间
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        preventClicksPropagation: false,
        on: {
          click: e => {
            // console.log(e.target.dataset.id)
            let targetId = e.target.dataset.id;
            let that = this;
            // console.log(this);
            let domlist = document.querySelectorAll(".slide");
            console.log(that.productList);
            let swiperList = that.productList;
            for (let index = 0; index < domlist.length; index++) {
              swiperList.forEach(item => {
                if (item.id == targetId) {
                  that.$router.push({
                    name: "detail",
                    query: {
                      id: item.id,
                      type: "product",
                      scene: 1,
                      category_id: 0,
                      keyword: ""
                    }
                  });
                }
              });
            }
          }
        }
      };
    }
    // ...mapGetters(["swiperData"]),
  },
  // watch:{
  //   "$store.state.material.pictureData": {
  //     deep: true,
  //     handler(newVal) {
  //       console.log(newVal)
  //       this.swiperList = newVal
  //     },
  //   },
  // },
  mounted() {
    // this.$store.dispatch("getIndexData");
    getIntroIndex().then(res => {
      this.introductionInfo = res.introduction;
      this.hotNewsList = res.hot_news;
      this.productList = res.product;
      this.swiperData = this.getswiperData(res.hot_news);
    });
    this.$store.dispatch("getPicture");
  },
  updated() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@keyframes fadeDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
  }
}

.home {
  .top_img {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .swiper {
    width: 100%;
    height: 680px;

    .swiper-wrapper {
      .slide-img {
        width: 100%;
        height: 100%;
      }
    }

    .my_pagination {
      :deep(.swiper-pagination-bullet:focus ) {
        outline: none;
      }

      :deep(.swiper-pagination-bullet-active ) {
        opacity: 1;
        background-clip: content-box;
        background: rgba(255, 255, 255, 0.5);
      }

      :deep(.swiper-pagination-bullet-active:before ) {
        content: '';
        position: absolute;
        height: 4px;
        left: 0;
        top: 0;
        width: 0;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        background-clip: content-box;
        -webkit-animation: bannerProgress 7.3s ease-in-out;
        -moz-animation: bannerProgress 7.3s ease-in-out;
        -o-animation: bannerProgress 7.3s ease-in-out;
        -ms-animation: bannerProgress 7.3s ease-in-out;
        animation: bannerProgress 7.3s ease-in-out;
        z-index: 186;
        overflow: hidden;
      }

      :deep(.swiper-pagination-bullet ) {
        position: relative;
        margin: 20px 10px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.5);
        opacity: 1;
        width: 50px;
        height: 4px;
        background-clip: content-box;
        z-index: 168;
        top: -3px;
      }
    }
  }

  .sd_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      font-size: 50px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 75px;
      background: linear-gradient(90deg, #2075EE 0%, #014EA2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 60px 0;
    }

    ul {
      width: 1180px;
      height: 440px;

      li {
        display: inline-block;
        width: 23.7%;
        height: 100%;
        overflow: hidden;
        position: relative;
      }

      .open {
        -webkit-transition: all 0.3s;

        .cover_box {
          opacity: 0;
        }

        .linner_box {
          // z-index: 8;
          .text_content {
            animation: fadeDown 0.5s linear;
          }
        }
      }

      .sd_item {
        -webkit-transition: all 0.3s;

        .cover_box {
          position: absolute;
          width: 280px;
          height: 440px;
          overflow: hidden;
          z-index: 2;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .linner_box {
          position: absolute;
          width: 880px;
          height: 440px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;

          .play_icon {
            width: 120px;
            height: 120px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .text_content_wrap {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 880px;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 53, 118, 0) 0%, rgba(0, 24, 65, 0.5) 100%);

            .text_content {
              padding: 38px 60px 60px 60px;
              box-sizing: border-box;

              .titles {
                font-size: 28px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 42px;
                margin-bottom: 20px;
              }

              p {
                font-size: 14px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 18px;
              }
            }
          }

          .img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .leader_box {
    height: 510px;
    background: #F0ECF7;
    display: flex;
    justify-content: center;
    align-items: center;

    .leader {
      display: flex;

      .leader_img {
        width: 330px;
        height: 330px;
        margin-right: 70px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .leader_content {
        .leader_header {
          display: flex;
          align-items: center;
          margin-top: 45px;
          margin-bottom: 40px;

          .name {
            font-size: 50px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 75px;
          }

          .tag {
            width: 130px;
            height: 40px;
            margin-left: 2px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .leader_txt {
          width: 780px;
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }
      }
    }
  }

  // 热点新闻
  .hot_news {
    display: flex;
    flex-direction: column;
    align-items: center;

    .new_title {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #000000;
      line-height: 54px;
      margin-top: 60px;
    }

    .new_sub_title {
      font-size: 14px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #192342;
      line-height: 21px;
      letter-spacing: 1px;
      margin-top: 20px;
    }

    .news_btn {
      font-size: 20px;
      font-family: AlibabaPuHuiTiR;
      line-height: 50px;
      width: 180px;
      height: 50px;
      // background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
      border-radius: 4px;
      text-align: center;
      margin: 40px 0 44px 0;
      cursor: pointer;
      border: 1px solid #014EA2;
      color: #014EA2;
      &:hover{
      background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
      color:#ffffff
    }
    }

    .new_box {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      width: 1220px;
      align-items: center;
      justify-content: center;
      margin-top: 40px;

      .swiper-pagination1 {
        :deep(.swiper-pagination-bullet) {
          margin-right: 10px;
        }

        :deep(.swiper-pagination-bullet-active ) {
          transform: scale(1.2);
        }
      }

      .swiper_box {
        width: 100%;
        height: 100%;

        .slide {
          &:nth-last-of-type(1) {
            margin-right: 0px;
          }
        }
      }

      .new_item_box {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;
        justify-content: space-between;
        // margin:0 10px;
        margin: 10px;
        margin-top: 40px;
      }

      .news_item {
        display: flex;
        align-items: center;
        width: 580px;
        height: 180px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        border: 4px solid #FFFFFF;
        margin-bottom: 20px;
        position: relative;

        .hot_img {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 36px;
          height: 18px;
        }

        .newsItem_logo {
          width: 50px;
          height: 40px;
          margin-right: 20px;
          margin-left: 40px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .newsItem_content {
          .newsItem_title {
            width: 390px;
            font-size: 20px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #333333;
            line-height: 30px;
            margin-bottom: 20px;
            white-space: nowrap;
            overflow: hidden;
            display: block;
            text-overflow: ellipsis;
          }

          .newsItem_txt {
            width: 430px;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #333333;

            // line-height: 20px;

            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 3;
            .newsinfo:hover {
              text-decoration: underline;
            }
          }
        }

        &:hover {
          cursor: pointer;
          // transform :scale(1.1)
          transform: translateY(-3px);
          transition: all 0.4s;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        }

        &:hover .newsItem_title {
          color: #014EA2;
        }
      }
    }
  }

  .product {
    background: #F4F6F7;
    display: flex;
    flex-direction: column;
    align-items: center;

    .product_title {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #000000;
      line-height: 54px;
      margin-top: 60px;
      margin-bottom: 20px;
    }

    .product_subTitle {
      font-size: 14px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #192342;
      line-height: 21px;
      letter-spacing: 1px;
    }

    .product_btn {
      font-size: 20px;
        font-family: AlibabaPuHuiTiR;
        line-height: 50px;
        width: 180px;
        height: 50px;
        // background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
        border-radius: 4px;
        text-align: center;
        margin: 40px 0 44px 0;
        cursor: pointer;
        border: 1px solid #014EA2;
        color: #014EA2;
        &:hover{
        background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
        color:#ffffff
      }
    }

    .swiper1 {
      width: 1200px;
      height: 370px;
      position: relative;

      .swiper_box {
        position: initial;
      }

      .swiper-container {
        padding: 40px 0;
        margin-left: 20px;

        .swiper-wrapper {
          .swiper-slide {
            width: 280px;
            height: 280px;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            // margin-right: 20px;
            overflow: hidden;

            &:last-of-type {
              margin-right: 0;
            }

            img {
              width: 100%;
              height: 100%;
              position: absolute;
              transition: all 0.3s;
            }

            .mask_wrap {
              position: absolute;
              width: 280px;
              height: 280px;
              background: linear-gradient(180deg, rgba(0, 53, 118, 0.1) 0%, rgba(0, 24, 65, 0.8) 100%);
              // display :none
              opacity: 0;

              .mask {
                margin: 190px 20px 0;

                .mask_title {
                  font-size: 20px;
                  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                  font-weight: 500;
                  color: #FFFFFF;
                  margin-bottom: 10px;
                  white-space: nowrap;
                  overflow: hidden;
                  display: block;
                  text-overflow: ellipsis;
                }

                .mask_txt {
                  height: 35px;
                  font-size: 14px !important;
                  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                  font-weight: 500;
                  color: #FFFFFF;
                  white-space: nowrap;
                  overflow: hidden;
                  display: block;
                  text-overflow: ellipsis;
                }
              }
            }

            &:hover .mask_wrap {
              display: block;
              opacity: 1;

              .mask {
                animation: fadeDown 0.5s linear;
              }
            }

            &:hover img {
              transform: scale(1.05);
            }
          }
        }

        .swiper-button-prev {
          position: absolute;
          left: -140px;
          z-index: 99;

          img {
            width: 70px;
            height: 110px;
          }
        }

        .swiper-button-next {
          position: absolute;
          right: -140px;
          z-index: 99;

          img {
            width: 70px;
            height: 110px;
          }
        }

        /* 先去掉默认样式 */
        .swiper-button-prev:after {
          display: none;
        }

        .swiper-button-next:after {
          display: none;
        }
      }
    }
  }

  .banner_img {
    width: 100%;
    height: 200px;

    .bottom_img {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }

    .swiper_box3 {
      width: 100%;
      height: 200px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.video_box {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .video_close {
    position: absolute;
    top: 100px;
    right: 100px;
  }

  .video_wrap {
    width: 900px;
    height: 750px;

    .video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #000000;
    }
  }
}

@keyframes bannerProgress {
  100% {
    width: 50px;
  }
}
</style>
